const applicationCarousel = document.getElementById('application-carousel')
const videoCarousel = document.getElementById('video-carousel')
let flag = true
applicationCarousel.addEventListener('slide.bs.carousel', function (e) {
    const bsVideoCarousel = bootstrap.Carousel.getInstance(videoCarousel)

    if (flag) {
        flag = false
        bsVideoCarousel.to(e.to)
    }
    else {
        flag = true
    }


})


videoCarousel.addEventListener('slide.bs.carousel', function (e) {

    const bsApplicationCarousel = bootstrap.Carousel.getInstance(applicationCarousel)

    if (flag) {
        flag = false
        bsApplicationCarousel.to(e.to)
    }
    else {
        flag = true
    }
})

const addAnimation = (current, newCurrent) => {
    current.classList.add('previous')
    newCurrent.classList.add('current')
    current.classList.remove('active')
    newCurrent.classList.add('active')
}

const removeAnimation = (current, newCurrent) => {
    newCurrent.classList.remove('current')
    current.classList.remove('previous')
}

// application systems dropdown
document.querySelectorAll(".app-steps-container .variant-dropdown").forEach((dropdown) => {
    dropdown.querySelectorAll(".variant-option-input").forEach((input) => {
        input.addEventListener("change", () => {
            dropdown.querySelector("button.dropdown-toggle span").textContent = input.dataset.variantTitle;

            //hide previous selected containers information
            const currentGif = document.querySelector(`#app-step-videos-container-${input.dataset.stepId} .app-steps-system-gif.active`)
            const newCurrentGif = document.getElementById(`app-step-video-${input.value}`)

            const currentContent = document.querySelector(`#app-step-container-${input.dataset.stepId} .app-steps-system-content.active`)
            const newCurrentContent = document.getElementById(`app-steps-content-${input.value}`)

            dropdown.classList.add('d-none')
            addAnimation(currentGif, newCurrentGif)
            addAnimation(currentContent, newCurrentContent)


            setTimeout(() => {
                removeAnimation(currentGif, newCurrentGif)
                removeAnimation(currentContent, newCurrentContent)
                dropdown.classList.remove('d-none')
            }, 600);

        })
    })
})

document.querySelectorAll(".daytime-products-buttons").forEach((container) => {
    container.querySelectorAll(".variant-option-input").forEach((input) => {
        input.addEventListener("change", () => {
            //hide previous selected containers information
            const currentGif = document.querySelector(`#app-step-videos-container-${input.dataset.stepId} .app-steps-system-gif.active`)
            const newCurrentGif = document.getElementById(`app-step-video-${input.value}`)

            const currentContent = document.querySelector(`#app-step-container-${input.dataset.stepId} .app-steps-system-content.active`)
            const newCurrentContent = document.getElementById(`app-steps-content-${input.value}`)


            addAnimation(currentGif, newCurrentGif)
            addAnimation(currentContent, newCurrentContent)


            setTimeout(() => {
                removeAnimation(currentGif, newCurrentGif)
                removeAnimation(currentContent, newCurrentContent)
            }, 600);

            //show and hide buttons
            document.querySelector(`#daytime-products-buttons-container-${input.dataset.stepId} .app-step-variant-button.d-none`).classList.remove('d-none')
            document.getElementById(`variant-option-${input.value}`).classList.add('d-none')
        })
    })
})

const dropdownToggles = document.querySelectorAll('#application-carousel .dropdown-toggle');

// Callback function to execute when mutations are observed
const dropdownToggleCallback = (mutationList, observer) => {
    for (const mutation of mutationList) {
        if (mutation.type === 'attributes' && mutation.attributeName === "class") {
            stopScrolling(mutation.target, 'application-dropdown-mobile-container')
        }

    }
};

const dropdownToggleObserver = new MutationObserver(dropdownToggleCallback);
Array.from(dropdownToggles).forEach(element => dropdownToggleObserver.observe(element, { attributes: true }));




$('#quick-view-modal').on('shown.bs.modal', async (e) => {
    const response = await fetch(e.relatedTarget.dataset.productUrl);
    const data = await response.text();

    const parser = new DOMParser();
    const newDocument = parser.parseFromString(data, "text/html");

    const quickViewContent = document.getElementById('quick-view-content')
    const quickViewLoad = quickViewContent.querySelector('#quick-view-load')

    newDocument.querySelectorAll('#product-page .carousel-item').forEach((item) => {
        item.classList.remove('pdp-item-carousel')
    })

    const productContainer = newDocument.getElementById('product-page-container')
    productContainer.classList.remove('row')
    productContainer.classList.add('d-flex')


    newDocument.querySelector('.product-carousel').classList.remove('sticky-carousel');

    newDocument.querySelectorAll('.wrapper-recharge-option label').forEach((el) => {
        el.htmlFor = 'quick-view-' + el.htmlFor
    })
    newDocument.getElementById('subscription-terms-link').id = 'quick-view-subscription-terms-link'
    newDocument.getElementById('product-form-header-desktop').id = 'quick-view-product-form-header-desktop'
    newDocument.getElementById('product-form-header-mobile').id = 'quick-view-product-form-header-mobile'
    newDocument.getElementById('recharge-widget-type-one-time').id = 'quick-view-recharge-widget-type-one-time'
    newDocument.getElementById('recharge-widget-type-subscription').id = 'quick-view-recharge-widget-type-subscription'

    newDocument.querySelectorAll('[name="recharge-widget-type"]').forEach(input => {
        input.setAttribute('name', 'quick-view-recharge-widget-type')
    })

    const productCarousel = newDocument.querySelector('.product-carousel-container')
    productCarousel.classList.remove('px-0')

    quickViewContent.replaceChild(newDocument.getElementById("product-page"), quickViewLoad)

    // Recharge widget
    quickViewContent.querySelectorAll('[name="quick-view-recharge-widget-type"]').forEach(input => {
        input.addEventListener('change', () => {
            updateRechargeWidgetPrices(input)
        })
    })

    quickViewContent.querySelectorAll("#recharge-widget-schedule-dropdown .recharge-widget-input").forEach((input) => {
        input.addEventListener("change", () => {

            const form = input.closest("form");
            form.querySelector(
                "button.recharge-widget-schedule-dropdown-toggle span"
            ).textContent = input.dataset.cartRechargePlanName;
        });
    });



    const dropdownToggles = quickViewContent.querySelectorAll('#product-page .dropdown-toggle');

    // Callback function to execute when mutations are observed
    const dropdownToggleCallback = (mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.type === 'attributes' && mutation.attributeName === "class") {
                stopScrolling(mutation.target, 'quick-view-dropdown-mobile-container')
            }

        }
    };

    const dropdownToggleObserver = new MutationObserver(dropdownToggleCallback);
    Array.from(dropdownToggles).forEach(element => dropdownToggleObserver.observe(element, { attributes: true }));


    $(document).ready(function () {
        $('#quick-view-subscription-terms-link').tooltip();
        $('#quick-view-subscription-terms-link').on('click', function () {
            $('#quick-view-subscription-terms-link').tooltip();
            $(this).mouseover();
        });
    });

})

$('#quick-view-modal').on("hidden.bs.modal", function () {
    const quickViewContent = document.getElementById('quick-view-content')
    quickViewContent.innerHTML = `
    <div id="quick-view-load">
    <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0016/8896/1122/files/output-onlinegiftools.gif?v=1710447357" alt="" height="auto" width="120">
    </div>
    `
});


function updateRechargeWidgetPrices(input) {
    const form = input.closest('form')

    if (input.value === 'one-time') {
        form.querySelector('#recharge-widget-schedule-list-wrapper').style.display = 'none'
        form.querySelector(".subscription-widget").classList.remove("active-recharge-widget");
        form.querySelector(".one-time-widget").classList.add("active-recharge-widget");

    } else {
        form.querySelector('#recharge-widget-schedule-list-wrapper').style.display = 'block'
        form.querySelector(".subscription-widget").classList.add("active-recharge-widget");
        form.querySelector(".one-time-widget").classList.remove("active-recharge-widget");

    }
    obRechargeSubscriptionChanged(input)
}

/*
 * OpenBorder/PMall functions
 **/
function obRechargeSubscriptionChanged(input) {
    const finalPriceEl = input
        .closest("#product-page-content")
        .querySelector("[data-product-price]");

    obUpdatePriceOnSubChange(finalPriceEl, input);
}

function obUpdatePriceOnSubChange(
    priceElement,
    input,
    priceAtt = "productPrice"
) {
    const variantId = input.getAttribute("data-pan-subscription-variant-id");
    const isCompare = priceAtt === "variantPriceCompare";

    return obUpdatePriceElement(priceElement, variantId, isCompare);
}

function obUpdatePriceElement(priceElement, variantId, isCompare) {
    const attributesToRemove = ["data-amount", "data-currency"];
    const newPriceElement = priceElement.cloneNode();
    const originalTextContent = priceElement.textContent;

    attributesToRemove.forEach(
        newPriceElement.removeAttribute.bind(newPriceElement)
    );

    newPriceElement.setAttribute("data-product-variant-id", variantId);
    if (isCompare) {
        newPriceElement.setAttribute("data-price-variant", "compare-at");
    }

    const priceInnerContainer = document.createElement("span");
    priceInnerContainer.setAttribute("data-role", "price");
    priceInnerContainer.textContent = originalTextContent;
    newPriceElement.textContent = "";
    newPriceElement.appendChild(priceInnerContainer);

    priceElement.parentNode.insertBefore(newPriceElement, priceElement);
    priceElement.remove();

    return newPriceElement;
}



function stopScrolling(e, container) {
    if (window.innerWidth > 991) {
        return
    }
    const dropDownOffset = document.getElementById(container);
    const bodyElement = document.querySelector('body');
    if (e.classList.contains('show')) {
        dropDownOffset.classList.add('show');
        bodyElement.classList.add('stop-scroll');
    } else {
        dropDownOffset.classList.remove('show');
        bodyElement.classList.remove('stop-scroll');
    }
}
